import {createContext} from 'react'

import {noop} from '@sdox/utils'

import type {MediaLibraryFileType} from './types'
import type {XcMediaRefFragment} from '@sdox/api'

interface MediaLibraryContextState {
  multiselect: boolean
  acceptedFileTypes: MediaLibraryFileType[]
  selectedMediaRefs: XcMediaRefFragment[]
  onChange: (item: XcMediaRefFragment) => void
  allFilters: MediaLibraryFileType[]
  selectedFilters: MediaLibraryFileType[]
  onFilterChange: (filter: MediaLibraryFileType) => void
  resetFilters: () => void
}

export const MediaLibraryContext = createContext<MediaLibraryContextState>({
  multiselect: false,
  acceptedFileTypes: [],
  selectedMediaRefs: [],
  onChange: noop,
  allFilters: [],
  selectedFilters: [],
  onFilterChange: noop,
  resetFilters: noop,
})
